import {
    CREATE_TRACK_MOD_LOG_PENDING,
    CREATE_TRACK_MOD_LOG_SUCCESS,
    CREATE_TRACK_MOD_LOG_FAILURE,
} from './actionTypes';

const initialState = {
    list: null,
    loading: false,
}

function trackModLogReducer(state = initialState, action) {

    switch (action.type) {
        case CREATE_TRACK_MOD_LOG_PENDING:
            return {
                ...state,
                loading: true,
            }
        case CREATE_TRACK_MOD_LOG_SUCCESS:
        case CREATE_TRACK_MOD_LOG_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        default:
            return state
    }
}

export { trackModLogReducer };
